import React, { useState } from 'react';
import { AppConfirmModal } from 'components';

export type CallbackActionType = (answer: boolean) => void;

export type ConfigDialogType = {
  title: string;
  message: string;
  actionCallback: CallbackActionType;
  textConfirmButton?: string;
  textDismissButton?: string;
}

interface Props {
  openDialog?: (config: ConfigDialogType) => void;
}

export const ConfirmDialogContext = React.createContext<Props>({});

const ConfirmDialogProvider = ({ children }) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const initialConfig: ConfigDialogType = {
    title: '',
    message: '',
    textConfirmButton: '',
    textDismissButton: '',
    actionCallback: () => {},
  };
  const [ dialogConfig, setDialogConfig ] = useState(initialConfig);

  const openDialog = ({
    title,
    message,
    textConfirmButton,
    textDismissButton,
    actionCallback,
  }: ConfigDialogType) => {
    setDialogOpen(true);
    setDialogConfig({ title, message, textConfirmButton, textDismissButton, actionCallback });
  };

  const resetDialog = () => {
    setDialogOpen(false);
    setTimeout(() => setDialogConfig(initialConfig), 500);
  };

  const onConfirm = () => {
    resetDialog();
    dialogConfig.actionCallback(true);
  };

  const onDismiss = () => {
    resetDialog();
    dialogConfig.actionCallback(false);
  };

  const onClose = () => {
    resetDialog();
  };

  return (
    <ConfirmDialogContext.Provider value={{ openDialog }}>
      <AppConfirmModal
        open={dialogOpen}
        title={dialogConfig.title}
        message={dialogConfig.message}
        textConfirmButton={dialogConfig.textConfirmButton}
        textDismissButton={dialogConfig.textDismissButton}
        onConfirm={onConfirm}
        onClose={onClose}
        onDismiss={onDismiss}
      />
      {children}
    </ConfirmDialogContext.Provider>
  );
};

export default ConfirmDialogProvider;
